import { takeLatest, call, put, all } from 'redux-saga/effects';
import axios from 'axios';
import axiosRetry from 'axios-retry';

import { rejectRequestSuccess, rejectRequestFailure } from './reject-request.actions';
import { RejectRequestActionTypes, RejectRequestStart } from './reject-request.types';

axiosRetry(axios, { retries: 2 });

const rejectRequest = async (messageId: string, programmatic: boolean | undefined) => {
    await axios.post<any>(`${process.env.REACT_APP_DEACTIVATOR_API}/deactivator/v1/deactivate/reject?programmatic=${programmatic}`, {
        messageId
    });
};

export function* rejectRequestSagaAsync(action: RejectRequestStart) {
    try {
        yield rejectRequest(action.payload.messageId, action.payload.programmatic);
        yield put(
            rejectRequestSuccess({
                isRejected: true
            })
        );
    } catch (error: any) {
        yield put(
            rejectRequestFailure({
                errorMessage: error.message
            })
        );
    }
};

export function* rejectRequestSaga() {
    yield takeLatest(RejectRequestActionTypes.REJECT_REQUEST_START, rejectRequestSagaAsync)
};

export function* rejectRequestSagas() {
    yield all([
        call(rejectRequestSaga),
    ]);
};
